module.exports = __webpack_public_path__ + "img/28.d6379e61.jpg";